<template>
	<transition
			name="custom-classes-transition" 
			:enter-active-class="$_mbTgDlg_styleComponentAnimation()">
		<template v-if="$_mbTgDlg_stateComponentIsInitialized">
			<v-tooltip top>
				<template v-slot:activator="{ on }">
					<v-btn	class="customVBtn"
							:color="isEmpty(messageState_.tag) ? 'secondary' : 'primary'"
							dark
							icon
							v-on="on"
							@click="$_mbTgDlg_open()">
						<v-icon>label</v-icon>
					</v-btn>
				</template>
				<template v-if="!isEmpty(messageState_.tag)">
					<span v-text="messageState_.tag.length + ' Tags'" />
				</template>
				<template v-else>
					Not Set
				</template>
				<v-dialog
						v-model="show_"
						max-width="600px"
						persistent>
					<v-card>
						<v-card-title>Tag</v-card-title>
						<v-card-text>
							<v-combobox
									clearable
									hide-details
									hide-no-data
									multiple
									outlined
									small-chips
									v-model="tag_" />
						</v-card-text>
						<v-card-actions>
							<v-row justify="center" dense>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbTgDlg_styleSaveButtonBlock"
											:color="$_mbTgDlg_styleSaveButtonColor"
											:dark="$_mbTgDlg_styleSaveButtonDark"
											:depressed="$_mbTgDlg_styleSaveButtonDepressed"
											:elevation="$_mbTgDlg_styleSaveButtonElevation"
											:large="$_mbTgDlg_styleSaveButtonLarge"
											:light="$_mbTgDlg_styleSaveButtonLight"
											:outlined="$_mbTgDlg_styleSaveButtonOutlined"
											:rounded="$_mbTgDlg_styleSaveButtonRounded"
											:small="$_mbTgDlg_styleSaveButtonSmall"
											:text="$_mbTgDlg_styleSaveButtonFlat"
											@click="$_mbTgDlg_save()">
										Save
									</v-btn>
								</v-col>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											:block="$_mbTgDlg_styleCloseButtonBlock"
											:color="$_mbTgDlg_styleCloseButtonColor"
											:dark="$_mbTgDlg_styleCloseButtonDark"
											:depressed="$_mbTgDlg_styleCloseButtonDepressed"
											:elevation="$_mbTgDlg_styleCloseButtonElevation"
											:large="$_mbTgDlg_styleCloseButtonLarge"
											:light="$_mbTgDlg_styleCloseButtonLight"
											:outlined="$_mbTgDlg_styleCloseButtonOutlined"
											:rounded="$_mbTgDlg_styleCloseButtonRounded"
											:small="$_mbTgDlg_styleCloseButtonSmall"
											:text="$_mbTgDlg_styleCloseButtonFlat"
											@click="$_mbTgDlg_close()">
										Close
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-tooltip>
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'MessagebarTagDialog',
		data() {
			return {
				componentName_: 'messagebarTagDialog',

				messageState_: {},

				tag_: [],

				show_: false
			}
		},
		computed: {
			// state
			$_mbTgDlg_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_mbTgDlg_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_mbTgDlg_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_mbTgDlg_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_mbTgDlg_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_mbTgDlg_inits(), 'component')
				}
			},
			$_mbTgDlg_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_mbTgDlg_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_mbTgDlg_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.$_mbTgDlg_inits(), 'chip')
			},
			$_mbTgDlg_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_mbTgDlg_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_mbTgDlg_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_mbTgDlg_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_mbTgDlg_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_mbTgDlg_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_mbTgDlg_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_mbTgDlg_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_mbTgDlg_styleCloseButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbTgDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbTgDlg_inits(), 'closeButton')
			},
			$_mbTgDlg_styleCloseButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbTgDlg_styleCloseButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbTgDlg_styleCloseButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbTgDlg_styleCloseButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbTgDlg_styleCloseButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbTgDlg_styleCloseButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbTgDlg_styleCloseButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbTgDlg_styleCloseButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbTgDlg_styleCloseButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbTgDlg_styleCloseButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbTgDlg_styleCloseButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleCloseButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_mbTgDlg_styleSaveButton() {
				const self_ = this;
				if(self_.isEmpty(self_.$_mbTgDlg_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_mbTgDlg_inits(), 'saveButton')
			},
			$_mbTgDlg_styleSaveButtonBlock() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_mbTgDlg_styleSaveButtonColor() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_mbTgDlg_styleSaveButtonDark() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_mbTgDlg_styleSaveButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_mbTgDlg_styleSaveButtonElevation() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_mbTgDlg_styleSaveButtonFlat() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_mbTgDlg_styleSaveButtonLarge() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_mbTgDlg_styleSaveButtonLight() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_mbTgDlg_styleSaveButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_mbTgDlg_styleSaveButtonRounded() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_mbTgDlg_styleSaveButtonSmall() {
				const self_ = this;
				const button_ = self_.$_mbTgDlg_styleSaveButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			}
		},
		beforeMount() {
			const self_ = this;
			
			self_.messageState_ = self_.getState('message')
		},
		methods: {
			$_mbTgDlg_open() {
				const self_ = this;

				self_.tag_ = self_.messageState_.tag;
				
				self_.show_ = true;
			},
			$_mbTgDlg_save() {
				const self_ = this;

				self_.messageState_.tag = self_.tag_;
				
				self_.$_mbTgDlg_close()
			},
			$_mbTgDlg_close() {
				const self_ = this;
				self_.show_ = false;
			}
		}
	}
</script>

<style scoped>
	.row_ {
		min-height: 64px;
	}
	.overflow_ {
		max-width: 35px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
	}
</style>
